import { ColumnProps as Column } from '@src/components/data.grid/models/column.props.configuration'

export const makeSearchItems = <T>(items: T[], columns: Column<T>[]) => {
  const result: { [key in keyof T]: string }[] = []
  items.forEach(item => {
    const searchItem: { [key in keyof T]: string } = {} as {
      [key in keyof T]: string
    }
    columns.forEach(column => {
      const value = item[column.field]
      if (column.type) return
      if (value === void 0 || typeof value === 'object') return
      searchItem[column.field] = (item[column.field] || '')
        .toString()
        .toLowerCase()
    })
    result.push(searchItem)
  })
  return result
}

function searchingDataView<D>(
  items: D[],
  columns: Column<D>[],
  searchValue: string
) {
  const searchItems = makeSearchItems(items, columns)

  const searchValueChucks = (searchValue || '')
    .toLocaleLowerCase()
    .split(' ')
    .map(x => x.replace(/\+/g, ' '))
    .filter(item => item !== null || item !== '')

  const reqValidChecks = searchValueChucks.length

  return items.filter((item, index) => {
    const searchItemValue = searchItems[index]
    let passedCheckCount = 0

    for (let i = 0, length = searchValueChucks.length; i < length; i++) {
      const searchValueChuck = searchValueChucks[i]
      for (const field in searchItemValue) {
        if (searchItemValue[field].indexOf(searchValueChuck) !== -1) {
          passedCheckCount++
          break
        }
      }
    }
    if (reqValidChecks > passedCheckCount) return false
    return true
  })
}

export default searchingDataView
